// extracted by mini-css-extract-plugin
export default {"main":"Awards_main__jn59W","imgCont":"Awards_imgCont__cTjTm"};